module.exports = __webpack_public_path__ + "static/media/LightShow.30c0ebf2.logo";